"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Cancel: function() {
        return Cancel;
    },
    Help: function() {
        return Help;
    },
    Backspace: function() {
        return Backspace;
    },
    Tab: function() {
        return Tab;
    },
    Clear: function() {
        return Clear;
    },
    Enter: function() {
        return Enter;
    },
    Shift: function() {
        return Shift;
    },
    Control: function() {
        return Control;
    },
    Alt: function() {
        return Alt;
    },
    Pause: function() {
        return Pause;
    },
    CapsLock: function() {
        return CapsLock;
    },
    Escape: function() {
        return Escape;
    },
    Convert: function() {
        return Convert;
    },
    NonConvert: function() {
        return NonConvert;
    },
    Accept: function() {
        return Accept;
    },
    ModeChange: function() {
        return ModeChange;
    },
    Space: function() {
        return Space;
    },
    PageUp: function() {
        return PageUp;
    },
    PageDown: function() {
        return PageDown;
    },
    End: function() {
        return End;
    },
    Home: function() {
        return Home;
    },
    ArrowLeft: function() {
        return ArrowLeft;
    },
    ArrowUp: function() {
        return ArrowUp;
    },
    ArrowRight: function() {
        return ArrowRight;
    },
    ArrowDown: function() {
        return ArrowDown;
    },
    Select: function() {
        return Select;
    },
    Print: function() {
        return Print;
    },
    Execute: function() {
        return Execute;
    },
    PrintScreen: function() {
        return PrintScreen;
    },
    Insert: function() {
        return Insert;
    },
    Delete: function() {
        return Delete;
    },
    Digit0: function() {
        return Digit0;
    },
    RightParenthesis: function() {
        return RightParenthesis;
    },
    Digit1: function() {
        return Digit1;
    },
    ExclamationPoint: function() {
        return ExclamationPoint;
    },
    Digit2: function() {
        return Digit2;
    },
    AtSign: function() {
        return AtSign;
    },
    Digit3: function() {
        return Digit3;
    },
    PoundSign: function() {
        return PoundSign;
    },
    Digit4: function() {
        return Digit4;
    },
    DollarSign: function() {
        return DollarSign;
    },
    Digit5: function() {
        return Digit5;
    },
    PercentSign: function() {
        return PercentSign;
    },
    Digit6: function() {
        return Digit6;
    },
    Caret: function() {
        return Caret;
    },
    Digit7: function() {
        return Digit7;
    },
    Ampersand: function() {
        return Ampersand;
    },
    Digit8: function() {
        return Digit8;
    },
    MultiplicationSign: function() {
        return MultiplicationSign;
    },
    Digit9: function() {
        return Digit9;
    },
    LeftParenthesis: function() {
        return LeftParenthesis;
    },
    a: function() {
        return a;
    },
    A: function() {
        return A;
    },
    b: function() {
        return b;
    },
    B: function() {
        return B;
    },
    c: function() {
        return c;
    },
    C: function() {
        return C;
    },
    d: function() {
        return d;
    },
    D: function() {
        return D;
    },
    e: function() {
        return e;
    },
    E: function() {
        return E;
    },
    f: function() {
        return f;
    },
    F: function() {
        return F;
    },
    g: function() {
        return g;
    },
    G: function() {
        return G;
    },
    h: function() {
        return h;
    },
    H: function() {
        return H;
    },
    i: function() {
        return i;
    },
    I: function() {
        return I;
    },
    j: function() {
        return j;
    },
    J: function() {
        return J;
    },
    k: function() {
        return k;
    },
    K: function() {
        return K;
    },
    l: function() {
        return l;
    },
    L: function() {
        return L;
    },
    m: function() {
        return m;
    },
    M: function() {
        return M;
    },
    n: function() {
        return n;
    },
    N: function() {
        return N;
    },
    o: function() {
        return o;
    },
    O: function() {
        return O;
    },
    p: function() {
        return p;
    },
    P: function() {
        return P;
    },
    q: function() {
        return q;
    },
    Q: function() {
        return Q;
    },
    r: function() {
        return r;
    },
    R: function() {
        return R;
    },
    s: function() {
        return s;
    },
    S: function() {
        return S;
    },
    t: function() {
        return t;
    },
    T: function() {
        return T;
    },
    u: function() {
        return u;
    },
    U: function() {
        return U;
    },
    v: function() {
        return v;
    },
    V: function() {
        return V;
    },
    w: function() {
        return w;
    },
    W: function() {
        return W;
    },
    x: function() {
        return x;
    },
    X: function() {
        return X;
    },
    y: function() {
        return y;
    },
    Y: function() {
        return Y;
    },
    z: function() {
        return z;
    },
    Z: function() {
        return Z;
    },
    OS: function() {
        return OS;
    },
    ContextMenu: function() {
        return ContextMenu;
    },
    F1: function() {
        return F1;
    },
    F2: function() {
        return F2;
    },
    F3: function() {
        return F3;
    },
    F4: function() {
        return F4;
    },
    F5: function() {
        return F5;
    },
    F6: function() {
        return F6;
    },
    F7: function() {
        return F7;
    },
    F8: function() {
        return F8;
    },
    F9: function() {
        return F9;
    },
    F10: function() {
        return F10;
    },
    F11: function() {
        return F11;
    },
    F12: function() {
        return F12;
    },
    F13: function() {
        return F13;
    },
    F14: function() {
        return F14;
    },
    F15: function() {
        return F15;
    },
    F16: function() {
        return F16;
    },
    F17: function() {
        return F17;
    },
    F18: function() {
        return F18;
    },
    F19: function() {
        return F19;
    },
    F20: function() {
        return F20;
    },
    F21: function() {
        return F21;
    },
    F22: function() {
        return F22;
    },
    F23: function() {
        return F23;
    },
    F24: function() {
        return F24;
    },
    NumLock: function() {
        return NumLock;
    },
    ScrollLock: function() {
        return ScrollLock;
    },
    VolumeMute: function() {
        return VolumeMute;
    },
    VolumeDown: function() {
        return VolumeDown;
    },
    VolumeUp: function() {
        return VolumeUp;
    },
    Semicolon: function() {
        return Semicolon;
    },
    EqualsSign: function() {
        return EqualsSign;
    },
    PlusSign: function() {
        return PlusSign;
    },
    Comma: function() {
        return Comma;
    },
    LeftAngleBracket: function() {
        return LeftAngleBracket;
    },
    MinusSign: function() {
        return MinusSign;
    },
    Underscore: function() {
        return Underscore;
    },
    Decimal: function() {
        return Decimal;
    },
    RightAngleBracket: function() {
        return RightAngleBracket;
    },
    ForwardSlash: function() {
        return ForwardSlash;
    },
    QuestionMark: function() {
        return QuestionMark;
    },
    GraveAccent: function() {
        return GraveAccent;
    },
    Tilde: function() {
        return Tilde;
    },
    LeftSquareBracket: function() {
        return LeftSquareBracket;
    },
    LeftCurlyBrace: function() {
        return LeftCurlyBrace;
    },
    BackSlash: function() {
        return BackSlash;
    },
    Pipe: function() {
        return Pipe;
    },
    RightSquareBracket: function() {
        return RightSquareBracket;
    },
    RightCurlyBrace: function() {
        return RightCurlyBrace;
    },
    SingleQuote: function() {
        return SingleQuote;
    },
    DoubleQuote: function() {
        return DoubleQuote;
    },
    Meta: function() {
        return Meta;
    },
    AltGraph: function() {
        return AltGraph;
    },
    Attn: function() {
        return Attn;
    },
    CrSel: function() {
        return CrSel;
    },
    ExSel: function() {
        return ExSel;
    },
    EraseEof: function() {
        return EraseEof;
    },
    Play: function() {
        return Play;
    },
    ZoomOut: function() {
        return ZoomOut;
    }
});
const Cancel = 3;
const Help = 6;
const Backspace = 8;
const Tab = 9;
const Clear = 12;
const Enter = 13;
const Shift = 16;
const Control = 17;
const Alt = 18;
const Pause = 19;
const CapsLock = 20;
const Escape = 27;
const Convert = 28;
const NonConvert = 29;
const Accept = 30;
const ModeChange = 31;
const Space = 32;
const PageUp = 33;
const PageDown = 34;
const End = 35;
const Home = 36;
const ArrowLeft = 37;
const ArrowUp = 38;
const ArrowRight = 39;
const ArrowDown = 40;
const Select = 41;
const Print = 42;
const Execute = 43;
const PrintScreen = 44;
const Insert = 45;
const Delete = 46;
const Digit0 = 48;
const RightParenthesis = 48;
const Digit1 = 49;
const ExclamationPoint = 49;
const Digit2 = 50;
const AtSign = 50;
const Digit3 = 51;
const PoundSign = 51;
const Digit4 = 52;
const DollarSign = 52;
const Digit5 = 53;
const PercentSign = 53;
const Digit6 = 54;
const Caret = 54;
const Digit7 = 55;
const Ampersand = 55;
const Digit8 = 56;
const MultiplicationSign = 56;
const Digit9 = 57;
const LeftParenthesis = 57;
const a = 65;
const A = 65;
const b = 66;
const B = 66;
const c = 67;
const C = 67;
const d = 68;
const D = 68;
const e = 69;
const E = 69;
const f = 70;
const F = 70;
const g = 71;
const G = 71;
const h = 72;
const H = 72;
const i = 73;
const I = 73;
const j = 74;
const J = 74;
const k = 75;
const K = 75;
const l = 76;
const L = 76;
const m = 77;
const M = 77;
const n = 78;
const N = 78;
const o = 79;
const O = 79;
const p = 80;
const P = 80;
const q = 81;
const Q = 81;
const r = 82;
const R = 82;
const s = 83;
const S = 83;
const t = 84;
const T = 84;
const u = 85;
const U = 85;
const v = 86;
const V = 86;
const w = 87;
const W = 87;
const x = 88;
const X = 88;
const y = 89;
const Y = 89;
const z = 90;
const Z = 90;
const OS = 91;
const ContextMenu = 93;
const F1 = 112;
const F2 = 113;
const F3 = 114;
const F4 = 115;
const F5 = 116;
const F6 = 117;
const F7 = 118;
const F8 = 119;
const F9 = 120;
const F10 = 121;
const F11 = 122;
const F12 = 123;
const F13 = 124;
const F14 = 125;
const F15 = 126;
const F16 = 127;
const F17 = 128;
const F18 = 129;
const F19 = 130;
const F20 = 131;
const F21 = 132;
const F22 = 133;
const F23 = 134;
const F24 = 135;
const NumLock = 144;
const ScrollLock = 145;
const VolumeMute = 181;
const VolumeDown = 182;
const VolumeUp = 183;
const Semicolon = 186;
const EqualsSign = 187;
const PlusSign = 187;
const Comma = 188;
const LeftAngleBracket = 188;
const MinusSign = 189;
const Underscore = 189;
const Decimal = 190;
const RightAngleBracket = 190;
const ForwardSlash = 191;
const QuestionMark = 191;
const GraveAccent = 192;
const Tilde = 192;
const LeftSquareBracket = 219;
const LeftCurlyBrace = 219;
const BackSlash = 220;
const Pipe = 220;
const RightSquareBracket = 221;
const RightCurlyBrace = 221;
const SingleQuote = 222;
const DoubleQuote = 222;
const Meta = 224;
const AltGraph = 225;
const Attn = 246;
const CrSel = 247;
const ExSel = 248;
const EraseEof = 249;
const Play = 250;
const ZoomOut = 251;
